import * as geolib from 'geolib';

/**
 * Calcula a área em hectares a partir de coordenadas de polígono
 * @param coords Array de coordenadas { lat: number, lng: number }[]
 * @returns Área em hectares formatada com 2 casas decimais
 */
export const calculateHectares = (coords: { lat: number; lng: number }[]): string => {
  if (!coords || coords.length < 3) {
    return '0.00';
  }

  try {
    // Converte coordenadas para o formato esperado pelo geolib
    const polygonCoords = coords.map(coord => ({
      latitude: coord.lat,
      longitude: coord.lng
    }));

    // Calcula área em metros quadrados e converte para hectares
    const areaInSquareMeters = geolib.getAreaOfPolygon(polygonCoords);
    const areaInHectares = areaInSquareMeters / 10000;
    
    return areaInHectares.toFixed(2);
  } catch (error) {
    console.error('Erro ao calcular hectares:', error);
    return '0.00';
  }
};
